import { ComponentIds, HierarchyUtils, } from "@inter-ikea-core/core";
import { entityIsSection } from "./attachedTo";
import { COMPONENT_IDS } from "../storage2ComponentIDs";
/**
 * This will remove the REMOVE_RIGHT_SIDE_UNIT_ID component,
 * removing this component will ensure that there are no weird result when adding the new entity to the scene.
 * @param copyEntity
 */
const removeComponent = (copyEntity) => {
    if (copyEntity.hasComponent(COMPONENT_IDS.REMOVE_RIGHT_SIDE_UNIT_ID)) {
        copyEntity.removeComponent(COMPONENT_IDS.REMOVE_RIGHT_SIDE_UNIT_ID);
    }
    if (copyEntity.hasComponent(COMPONENT_IDS.REMOVE_LEFT_SIDE_UNIT_ID)) {
        copyEntity.removeComponent(COMPONENT_IDS.REMOVE_LEFT_SIDE_UNIT_ID);
    }
};
/**
 * Get the parent entity of the selected entity
 * @param selectedEntity
 * @returns
 */
const getParentEntity = (selectedEntity) => {
    const parentEntity = HierarchyUtils.parent(selectedEntity);
    if (!parentEntity)
        throw new Error("Entity is missing a parent entity");
    return parentEntity;
};
/**
 * Duplicates the selected entity and all of its children
 * @param core
 * @param placementService
 * @returns
 */
export const duplicateEntity = (core, placementService) => {
    const selectedEntity = core.services.entityManager.entities.find((entity) => entity.hasComponent(ComponentIds.SELECTED_COMPONENT_ID));
    if (!selectedEntity)
        throw new Error("Found no entity that is selected");
    const parentEntity = getParentEntity(selectedEntity);
    const copyEntity = HierarchyUtils.duplicateEntity(selectedEntity, core.services);
    if (entityIsSection(selectedEntity)) {
        removeComponent(copyEntity);
    }
    // Try to add it to the same section that the insert is currently sitting in
    let placementResult = selectedEntity.hasComponent(COMPONENT_IDS.INSERT)
        ? placementService.snapToTarget(copyEntity, parentEntity)
        : undefined;
    if (!(placementResult === null || placementResult === void 0 ? void 0 : placementResult.valid)) {
        placementResult = placementService.snapToScene(copyEntity);
        if (!placementResult.valid) {
            // If the placement should fail, this will remove the copyEntity from the entityManager
            core.services.entityManager.disposeEntity(copyEntity);
        }
    }
    return placementResult;
};
